import React from 'react';
import { Button, ButtonGroup } from '@trussworks/react-uswds';

export function USWDSButton(props) {
  return <Button {...props} />;
}
export function USWDSButtonGroup(props) {
  return <ButtonGroup {...props} />;
}
